// Navbar
export const NavbarItem1 = `Home`;
export const NavbarItem2 = `About us`;
export const NavbarItem3 = `Events`;
export const NavbarItem4 = `Contact us`;
export const NavbarItem5 = `Our Team`;
export const NavbarItem6 = `Sponsors`;
export const NavbarItem7 = `Collab`;

// Footer
export const FooterSiteMap = `SITEMAP`;
export const FooterSite1 = `Home`;
export const FooterSite2 = `About Us`;
export const FooterSite2mobile = `About`;
export const FooterSite3 = `Our Events`;
export const FooterSite3mobile = `Events`;
export const FooterSite4 = `Site info`;
export const FooterSite5 = `Terms & Condition`;
export const FooterGetInTouch = `GET IN TOUCH`;
export const FooterGetInTouch1 = `Blog`;
export const FooterGetInTouch2 = `Contact Us`;
export const FooterGetInTouch2mobile = `Contact`;
export const FooterGetInTouch3 = `Our Team`;
export const FooterGetInTouch3mobile = `Team`;
export const FooterGetInTouch4 = `Sponsors`;
export const FooterSocials = `SOCIAL MEDIA`;
export const FooterSocials1 = `Twitter`;
export const FooterSocials2 = `Instagram`;
export const FooterSocials3 = `Linkedin`;
export const FooterSocials4 = `Youtube`;
export const FooterDashboard = `Join Dashboard to get event updates and other notifications from us.`;
export const FooterDashboardButton = `Join Dashboard`;

// Landing
export const LandingHeading = `"A Place Where ideas turn into reality !"`;
export const LandingHeading1 = `"Place where ideas`;
export const LandingHeading2 = `Turn into reality !"`;
export const LandingButton = `Join Us`;
export const LandingInfo = `Developer Student Clubs are university based community groups
									for students interested in Google developer technologies.
									Students from all undergraduate or graduate programs with an
									interest in growing as a developer are welcome.`;

// Sponsor
export const SponsorHeading = `Sponsors`;
export const SponsorInfo = `We have some amazing sponsors lined up. Here they are !`;

// Collab Page
export const CollabHeading = `Want to Collaborate with us ?`;
export const CollabInfo = `Developer Student Clubs are university based community groups
for students interested in Google developer technologies.
Students from all undergraduate or graduate programs with an
interest in growing as a developer are welcome.`;
export const CollabInfo2 = `Come on! Let's do it together!`;
export const CollabButton = `Let us know you more`;

// Sponsor Page
export const SponsorButton = `Sponsor us`;

// Contact Us
export const ContactUsHeading = `Feel free to send us your message`;
